"use client";

import {
  GuestOnlyPage,
  View,
} from "@/components";

import { useResetPasswordToken } from "../../_hooks";
import {
  ConfirmResetPasswordFormHeader,
  ResetPasswordPageContainer,
  ConfirmResetPasswordForm,
  ResetPasswordPageHeader,
} from "..";
import { Flex } from "@vetty/ui";

/**
 * ResetPasswordPageView Component
 *
 * Main reset password page with form and header components.
 * Handles password reset flow for users who forgot their credentials.
 */
export const ResetPasswordPageView = () => {
  // Initialize token verification and form setup
  useResetPasswordToken();

  return (
    <GuestOnlyPage redirectTo={"/"}>
      <View>
        <Flex direction={"column"}>
          {/* Page header with navigation */}
          <ResetPasswordPageHeader />

          {/* Main content area */}
          <ResetPasswordPageContainer>
            {/* Form header with instructions */}
            <ConfirmResetPasswordFormHeader />

            {/* Reset password form */}
            <ConfirmResetPasswordForm />
          </ResetPasswordPageContainer>
        </Flex>
      </View>
    </GuestOnlyPage>
  );
};
